import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Remove any external badges
const removeExternalBadges = () => {
  const selectors = [
    '#emergent-badge',
    'a[href*="emergent"]',
    'a[href*="emergentagent"]',
    '[id*="emergent"]'
  ];
  selectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(el => el.remove());
  });
};

// Run on load and periodically
removeExternalBadges();
setInterval(removeExternalBadges, 1000);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
